import { NavLink } from "react-router";
import { Item, ItemActions, ItemContent, ItemDescription, ItemTitle } from "@cmde/shadcn";
import { ChevronRightIcon } from "lucide-react";
import { RoutePaths } from "@/config/route-paths";
import { env } from "@/config/environment-vars";
import { useTranslation } from "react-i18next";

export default function NoCustomerSelected() {
  const { t } = useTranslation();

  return (
    <div className="grid h-full place-content-center gap-4">
      <Item variant="outline">
        <ItemContent>
          <ItemTitle>{t("customers.no_customer_selected.title")}</ItemTitle>
          <ItemDescription>
            {t("customers.no_customer_selected.description", { projectTitle: env.VITE_PROJECT_TITLE })}
          </ItemDescription>
        </ItemContent>
        <ItemActions>
          <NavLink to={RoutePaths.customers.list()}>
            <ChevronRightIcon className="size-4" />
          </NavLink>
        </ItemActions>
      </Item>
    </div>
  );
}
